<template>
  <div class="fu-drtab" data-test="fu-drawer-treatment">
    <p v-if="!items.length" class="fu-drtab__empty" data-test="fu-drawer-treatment-empty">No unscheduled treatment.</p>
    <div v-for="(it, i) in items" :key="i" class="fu-drtab__item">
      <span class="fu-drtab__code">{{ it.code }}</span>
      <div class="fu-drtab__main">
        <div class="fu-drtab__head">
          <span class="fu-drtab__item-title">{{ it.title }}</span>
          <span v-if="it.priority" class="fu-drtab__badge">{{ it.priority }}</span>
        </div>
        <div v-if="it.meta" class="fu-drtab__meta">{{ it.meta }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * DrawerTreatmentTab — "Treatment": today's "Unscheduled Treatment" table (recall: pending tx;
 * unscheduled treatment: tx in plan) — Priority, ProcCode, ToothNum + Surf (ctx.formatTooth: Canada's
 * FDI numbering lives in the mixin), Descript, DateTP. No fees: today's result sets carry none (the
 * design's "$X planned" line is follow-on). Presentational.
 */
export default {
  name: 'DrawerTreatmentTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  computed: {
    items() {
      const rows = (this.tab.sections || []).reduce((all, s) => all.concat(s.rows || []), []);
      return rows.map((tx) => {
        const tooth = [this.ctx.formatTooth(tx.ToothNum), tx.Surf].filter(x => x !== null && x !== undefined && String(x).trim() !== '').join(' ');
        const planned = tx.DateTP ? `planned ${this.ctx.formatDate(tx.DateTP)}` : '';
        return {
          code: tx.ProcCode || '—',
          title: tx.Descript || tx.ProcCode || 'Procedure',
          priority: tx.Priority || '',
          meta: [tooth ? `Tooth ${tooth}` : '', planned].filter(Boolean).join(' · '),
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }
.fu-drtab__item { @include fu-dr-item; }
.fu-drtab__code { @include fu-dr-code-chip; }
.fu-drtab__main { flex: 1; min-width: 0; }
.fu-drtab__head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.fu-drtab__item-title { @include fu-dr-item-title; }
.fu-drtab__badge { @include fu-pill($fu-warning-subtle, #7a4d0c); }
.fu-drtab__meta { @include fu-dr-item-meta; }
</style>
